import changeToTime from './change-to-time';
import changeToLocation from './change-to-location';
import changeToDevice from './change-to-device';
import { ABANDON_ADD_ANOTHER_DEVICE, ADD_ANOTHER_DEVICE } from './';

const deviceRoutes = ['device', 'brand', 'model', 'color'];

export default function addAnotherDevice() {
  return async (dispatch, getState) => {
    dispatch({ type: ADD_ANOTHER_DEVICE });

    dispatch(changeToDevice());
  };
}

export function abandonAddAnotherDevice() {
  return async (dispatch, getState) => {
    const {
      group: { slug },
      routing: {
        locationBeforeTransitions: { pathname = '' },
      },
    } = getState();

    dispatch({ type: ABANDON_ADD_ANOTHER_DEVICE });

    const matches = pathname.match(/([A-Za-z]+)$/);

    if (matches && deviceRoutes.includes(matches[0])) {
      if (slug.includes('rutgers')) {
        dispatch(changeToTime());
      } else {
        dispatch(changeToLocation());
      }
    }
  };
}
